module.exports = __webpack_public_path__ + "static/media/insight-hero.17195f0e.svg";